export type AnalyticsConsent = "granted" | "denied";

/**
 * Explicit analytics consent, stored per-device. Distinct from the legacy
 * `mj_cookie_notice` implied-consent key on purpose: visitors who merely
 * dismissed the old notice are re-asked once for an explicit decision.
 */
const STORAGE_KEY = "mj_analytics_consent";
const EVENT_NAME = "mj:analytics-consent";

export function readAnalyticsConsent(): AnalyticsConsent | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw === "granted" || raw === "denied" ? raw : null;
  } catch {
    return null;
  }
}

export function writeAnalyticsConsent(value: AnalyticsConsent): void {
  try {
    localStorage.setItem(STORAGE_KEY, value);
  } catch {
    // private mode — the banner simply reappears next visit
  }
  window.dispatchEvent(new CustomEvent<AnalyticsConsent>(EVENT_NAME, { detail: value }));
}

export function onAnalyticsConsent(cb: (value: AnalyticsConsent) => void): () => void {
  const handler = (e: Event) => cb((e as CustomEvent<AnalyticsConsent>).detail);
  window.addEventListener(EVENT_NAME, handler);
  return () => window.removeEventListener(EVENT_NAME, handler);
}
